import React from 'react';
interface SegmentedProps<T extends string> {
  label: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (value: T) => void;
}
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange
}: SegmentedProps<T>) {
  return <div role="radiogroup" aria-label={label} className="inline-flex rounded-lg bg-proto-chip p-0.5" data-id="element-421" data-mp="2m77zmbu5mcbh">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" role="radio" aria-checked={active} onClick={() => onChange(o.value)} className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors duration-150 ${active ? 'bg-white text-proto-ink shadow-sm' : 'text-proto-muted hover:text-proto-ink'}`} data-id="element-422" data-mp="1ug1s3ac3tcc6">
            {o.label}
          </button>;
    })}
    </div>;
}